<template>


<div class="">



        
            <cReviewHotel :hotelObj="hotelObj" :isToggleOption="true" :isEditOption="true" :isShowLeftPart="true" :isHideDetails="true"/>
 <CButton @click="navToNew()">
      Add New
    </CButton>


 </div>
</template>
<script>
import cReviewHotel from "../../../../../components/hms/cReviewHotel";
import router, { navigate } from "../../../../../router/index";
import { COMPONENT_NAME,PATHNAME } from '../../../../../util/constants';
import BaseConfiguration from "../../../../../config/base.js";
import Logger from "../../../../../services/logger";
import SERVICE_URL, {
  FILE_NAME,
  LOG_TYPE,
  HTTP_CODES,
} from "../../../../../config/API_DATA";
import { mapGetters } from 'vuex';

export default {
    name: COMPONENT_NAME.SURCHARGE_ALL,

  components: {
    cReviewHotel,
  },
   data: () => {
    return {
     
    };
  },
  computed: {
   ...mapGetters("shmsManage", {
      hotelObj: "GET_SEL_HOTEL",
      
    }),
    
  },

  methods: {
    
        navToNew() {
             try {
               if(BaseConfiguration.isDebug) console.log("navToNew");
            navigate(PATHNAME.SURCHARGE_NEW)
         
             } catch (err) {
                     let body = Logger.buildRequest(
                       FILE_NAME.SURCHARGE_ALL,
                       "error in navToNew",
                       err.toString(),
                       "navToNew",
                       LOG_TYPE.ERROR
                     );
                     Logger.getResponse(body);
                   }
             
             }, 
  }
}
</script>